import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import type { JoinLinkRange } from "@/components/join-links/joinLinkRange";
import type { JoinLinkDayResponse, JoinLinkSummaryResponse } from "@/types/generated/cms.generated";

/**
 * Join-link stats (CMS API `join-links`; AthlynAdmin + AthlynTeam, platform-wide).
 * `from` / `to` are UAE days (`yyyy-mm-dd`, inclusive). Counts only — no personal data.
 */

/** One row per active company, ordered by name, for the range. */
export function useJoinLinks(range: JoinLinkRange) {
  return useQuery<JoinLinkSummaryResponse[]>({
    queryKey: ["join-links", range.from, range.to],
    queryFn: () =>
      apiRequest<JoinLinkSummaryResponse[]>("GET", `/join-links?from=${range.from}&to=${range.to}`),
  });
}

/** Every UAE day of the range for one company, zero-filled, oldest first. Idle without an id. */
export function useJoinLinkDaily(organizationId: string | null | undefined, range: JoinLinkRange) {
  return useQuery<JoinLinkDayResponse[]>({
    queryKey: ["join-links", "daily", organizationId, range.from, range.to],
    queryFn: () =>
      apiRequest<JoinLinkDayResponse[]>(
        "GET",
        `/join-links/${encodeURIComponent(organizationId ?? "")}/daily?from=${range.from}&to=${range.to}`
      ),
    enabled: !!organizationId,
  });
}
